// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__7ZAzu","time":"style_time__UJIpe","description":"style_description__2nb6W"};